import Category from '@shared/classes/category';
import categoriesObservable from '../../api/categories/observable';
import updateCategories from './updateCategories';

export default function initCategories() {
  categoriesObservable.subscribe({
    next: (val: Category[]) => {
      updateCategories(val);
    },
    error: () => {
      console.error('Error recovering categories');
    },
    complete: () => {
      return null;
    },
  });
}
